/**
 * بدون میوتیت کردن آرایه اصلی, ایندکس خاصی از آرایه را حذف میکند و یک آرایه جدید را برمیگرداند.
 * @param {Array} array آرایه
 * @param {Number} i ایندکس برای حذف
 */
const delIdx = (array, i) => (array || []).filter((e, j) => j !== i);

export { delIdx };
